/* global axios */
import ApiClient from './ApiClient';

class AiProviderAPI extends ApiClient {
  constructor() {
    super('ai_provider', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, data);
  }
}

export default new AiProviderAPI();
